import { Pencil } from '@cat-home-experts/mortar-iconography-web/Pencil';
import Image from 'next/image';

import Title from '../components/Title';

import Footer from '../components/Footer';

import {
  useJobRefinementState,
  HIDE_SUMMARY,
  REQUEST_EDIT,
} from '../JobRefinement.reducer';

type Props = {
  onNext: () => void;
};

const JobSummary = ({ onNext }: Props) => {
  const { state, dispatch } = useJobRefinementState();
  const { answeredQuestions, form, category, isFormCompleted } = state;

  const handleNext = () => {
    dispatch({ type: HIDE_SUMMARY });
    onNext();
  };

  const onRequestEdit = (questionIndex: number) => (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: REQUEST_EDIT, payload: { questionIndex } });
  };

  return (
    <>
      <section className="flex h-screen flex-col justify-between overflow-auto">
        <div className="mb-[88px] sm:mb-0">
          <div className="mb-1 flex items-center justify-between">
            <Title
              title="Here's a summary of your job"
              description="See anything that needs updating? Make the changes now, then select ‘next’ when you’re ready"
              className="mb-4"
            />
          </div>
          {category?.label && (
            <div className="mb-4 flex items-center justify-between rounded-lg bg-neutral-extraSoft px-3 py-2">
              <div>
                <p className="mb-1 text-xs text-neutral-600">
                  Expertise needed
                </p>
                <p className="pr-1 text-sm">{category.label}</p>
              </div>
            </div>
          )}
          {form.questions?.map((question, index) => {
            const answers = answeredQuestions.get(question.questionId)?.answers;
            if (question.format === 'PHOTO_UPLOAD') {
              return (
                <div
                  key={question.questionId}
                  className="mb-4 flex items-center justify-between rounded-lg bg-neutral-extraSoft px-3 py-2"
                >
                  <div>
                    <p className="mb-1 text-xs text-neutral-600">Photos</p>
                    <div className="flex flex-wrap gap-2 pr-1">
                      {answers?.map(({ url, key, value }) =>
                        url ? (
                          <Image
                            className="aspect-square object-cover"
                            src={url}
                            key={key}
                            alt={value}
                            width={90}
                            height={90}
                          />
                        ) : (
                          value
                        ),
                      )}
                    </div>
                  </div>
                  <button
                    className="ml-3 cursor-pointer"
                    onClick={onRequestEdit(index)}
                    aria-label={`Edit ${question.title}`}
                  >
                    <Pencil color="" size={16} className=" fill-default-700" />
                  </button>
                </div>
              );
            }

            return (
              <div
                key={question.questionId}
                className="mb-4 flex items-center justify-between rounded-lg bg-neutral-extraSoft px-3 py-2"
              >
                <div>
                  <p className="mb-1 text-xs text-neutral-600">
                    {question.title}
                  </p>
                  <p className="pr-1 text-sm">
                    {answers?.map(v => v.value).join(', ') || '-'}
                  </p>
                </div>
                <button
                  className="ml-3 cursor-pointer"
                  onClick={onRequestEdit(index)}
                  aria-label={`Edit ${question.title}`}
                >
                  <Pencil color="" size={16} className=" fill-default-700" />
                </button>
              </div>
            );
          })}
        </div>
        <div className="sticky bottom-0 bg-white sm:sticky sm:w-full">
          <Footer
            disablePrimary={!isFormCompleted}
            primaryLabel="Next"
            handlePrimaryButton={handleNext}
            secondaryLabel="Cancel"
          />
        </div>
      </section>
    </>
  );
};

export default JobSummary;
